"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NativeEventDrivenServer = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const utils_1 = require("./utils");
class NativeEventDrivenServer extends web_ui_framework_1.HttpEventDrivenServer {
    constructor(_eventBus, getMobileConnector) {
        super(_eventBus);
        this.getMobileConnector = getMobileConnector;
        this.doRequest = (request) => {
            if (!Object.values(web_ui_framework_1.RequestMethod).includes(request.method)) {
                return Promise.reject((0, web_ui_framework_1.createFetchError)(request.id, `Native event Driven Server Error: The method "${request.method}" is not supported`));
            }
            const nativeRequest = (0, utils_1.createRequest)(request);
            return this.getMobileConnector()
                .fetch(nativeRequest)
                .then(nativeResponse => {
                const fetchResponse = (0, utils_1.createResponse)(nativeResponse);
                return fetchResponse;
            })
                .catch(() => {
                return (0, web_ui_framework_1.createFetchError)(request.id, 'Native event Driven Server Error: MobileConnector "fetch" method failed');
            });
        };
    }
}
exports.NativeEventDrivenServer = NativeEventDrivenServer;
//# sourceMappingURL=NativeEventDrivenServer.js.map